"use client";
import { useParams, useRouter } from "next/navigation";
import { useEffect } from "react";
import { useClientSideAuth, useTNFromParams } from "@/hooks";

export default function AuditLogsRedirect() {
    const params = useParams<{ tn: string }>();
    const { tn } = useTNFromParams(params);
    const router = useRouter();
    useClientSideAuth();

    useEffect(() => {
        if (tn !== null && tn !== "") {
            router.replace(`/audit-logs/${tn}`);
        }
    }, [tn, router]);

    return null;
}
